import React, { useState } from "react";

import FacilitySettingItem from "./FacilitySettingItem";
import SettingsTutorial from "../SettingsTutorial";
import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import Settings from "../../../../common/mypage/user-settings/Settings";

import ImageFacility from "../../../../assets/img/facility/facility-setting-setsumei.webp";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";

import {
  useGetFacility,
  useRequestFacilityApproval,
  useUpdateFacility,
} from "../../../../utils/useFacility";
import { PageVisibility } from "../../../../utils/PageVisibility";

const FacilitySettingContainer: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);

  const queryArgs = {
    authToken: auth_token,
    per: -1,
  };

  const {
    items: { facilities },
    isLoading,
  } = useGetFacility(queryArgs);

  const { mutateAsync, mutateLoading } = useUpdateFacility([
    "facility",
    queryArgs,
  ]);

  const { requestAsync, requestLoading } = useRequestFacilityApproval([
    "facility",
    queryArgs,
  ]);

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [currentMenu, setCurrentMenu] = useState<number>();

  const tutorial = (
    <SettingsTutorial
      img_src={ImageFacility}
      title="eスポーツ施設とは？"
      explanation="eスポーツカフェ、ゲーミングカフェ、eスポーツバー、ゲームセンター、イベントホールなどの施設情報を掲載できます。施設のご担当者の方はもちろん、一般ユーザーもご利用いただけます。あなたのオススメ施設を登録して知ってもらいませんか？ご登録お待ちしています！"
    />
  );

  const completeHandler = () => {
    setIsComplete(false);
  };

  const handlePrivate = async (id: string) => {
    if (auth_token && id)
      mutateAsync({
        authToken: auth_token,
        update: {
          sonic_id: id,
          sonic_status: PageVisibility.NotPubliclyVisible,
        },
      });
  };

  const handlePublish = async (id: string) => {
    if (auth_token && id) {
      await requestAsync({ auth_token: auth_token, id: id });
      setIsComplete(true);
    }
  };

  const handleDeletionRequest = async (id: string) => {
    if (auth_token && id)
      mutateAsync({
        authToken: auth_token,
        update: {
          sonic_id: id,
          sonic_status: PageVisibility.DeletionRequest,
        },
      });
  };

  if (isComplete)
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        title="公開申請完了"
        text={
          "公開申請が完了しました。\nこれより審査を開始します。\n結果通知までしばらくお待ちください。"
        }
        sub_text="※内容によっては数日お時間をいただく可能性がございます。"
      />
    );

  if (isLoading || mutateLoading || requestLoading)
    return <LoadingSpinner space={1} />;

  return (
    <Settings
      type="施設"
      description={
        "eスポーツ施設を作成してSELeCTに公開しましょう。集客に繋げたり、簡易的な公式サイトとしてのご利用もOKです！"
      }
      link="/mypage/facility-setting/create"
      tutorial={tutorial}
      currentMenu={currentMenu}
    >
      {facilities.length > 0
        ? facilities.map((facility, i) => (
            <FacilitySettingItem
              key={facility.id}
              id={facility.id}
              name={facility.name}
              img={facility.imgs?.[0]}
              status={facility.status}
              prefecture={facility.prefecture}
              handleMenu={() =>
                setCurrentMenu(i === currentMenu ? undefined : i)
              }
              isMenuOpen={currentMenu === i ? true : false}
              handlePublish={handlePublish}
              handlePrivate={handlePrivate}
              handleDeletionRequest={handleDeletionRequest}
            />
          ))
        : null}
    </Settings>
  );
};

export default FacilitySettingContainer;
